import { usePreventUnload } from "./usePreventUnload";
import { useReactRouterBlocker } from "./useReactRouterBlocker";

type UseNavigationBlockerParams = {
	shouldBlock: boolean;
	message: string;
};

/**
 * Hook to block navigation
 * Combines React Router navigation blocking and browser beforeunload event
 */
export const useNavigationBlocker = ({ shouldBlock, message }: UseNavigationBlockerParams) => {
	useReactRouterBlocker({ shouldBlock, message });
	usePreventUnload({ shouldPrevent: shouldBlock, message });
};

export default useNavigationBlocker;
